import { jsx as e, Fragment as m, jsxs as c } from "react/jsx-runtime";
import d from "react";
import { S as u } from "./ImageCarousel-rVtFRbaH.js";
import { T as y } from "./useMediaQuery-BZAMobKw.js";
import { b as f } from "./InfoCardGrid-CVf_t4co.js";
import { B as n } from "./BuildingCard-DK7g1PNq.js";
import { A as w } from "./ApartmentCard-BfyZfamk.js";
const i = {
  "autoplay-card-carousel": "elo-autoplay-card-carousel",
  "autoplay-card-carousel__title": "elo-autoplay-card-carousel__title"
}, j = d.forwardRef(({ buildingCardData: l, title: h, apartmentCardData: o }, t) => {
  const p = o && (o == null ? void 0 : o.length) > 0 ? 1.5 : 2.3;
  return /* @__PURE__ */ e(m, { children: l && l.length > 0 || o && o.length > 0 ? /* @__PURE__ */ c("div", { ref: t, className: i["autoplay-card-carousel"], children: [
    /* @__PURE__ */ e(
      y,
      {
        type: "heading",
        size: "medium",
        extraClass: i["autoplay-card-carousel__title"],
        children: h
      }
    ),
    /* @__PURE__ */ c(
      f,
      {
        autoPlay: !0,
        pauseButton: !0,
        slidesToShowMobile: 1.2,
        slidesToShowTablet: p,
        slidesToShowDesktop: 3.2,
        slidesToShowLargeDesktop: 3.7,
        displayArrows: !0,
        speed: 5500,
        className: "autoplay-card",
        children: [
          l && l.length > 0 && l.map((s, r) => /* @__PURE__ */ e(u, { children: /* @__PURE__ */ e(n, { ...s, size: "small" }) }, r)),
          o && o.length > 0 && o.map((s, r) => /* @__PURE__ */ e(u, { children: /* @__PURE__ */ e(w, { ...s }) }, r))
        ]
      }
    )
  ] }) : null });
});
export {
  j as A
};
